import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Content from "./content";
/**
 * Support
 *
 * کامپوننت صفحه پشتیبانی.
 *
 * ویژگی‌ها:
 * - استفاده از BoxLayoutContent برای قاب‌بندی کلی صفحه
 * - نمایش عنوان صفحه با آیکون ایمیل و متن "پشتیبانی"
 * - رندر کامپوننت Content که شامل محتوای اصلی پشتیبانی و ارسال پیام به ادمین است
 *
 * @returns JSX.Element
 */
// Task Response: کد کاملاً صحیح است و هیچ مشکلی ندارد.
// نکته بهینه‌سازی: اگر قصد دارید آیکون و متن عنوان همواره در یک خط و راست‌چین باشند، می‌توانید StackKit را با justifyContent="flex-start" و alignItems="center" تنظیم کنید تا نمایش بهتر شود.

const Support = () => {
  return (
    <BoxLayoutContent
      titleElement={
        <StackKit direction={"row"} gap={2}>
          <TypoGraphyKit variant="h6">
            <EmailOutlinedIcon />
          </TypoGraphyKit>
          <TypoGraphyKit variant="h6"> پشتیبانی</TypoGraphyKit>
        </StackKit>
      }
    >
      <Content />
    </BoxLayoutContent>
  );
};

export default Support;
